import {get as _get} from 'lodash';

/**
 * Reads a persisted slice from a redux-persist REHYDRATE action.
 *
 * @param {object} action
 * @param {string} path
 * @param {*} initialState
 * @returns {*}
 */
export const mergeRehydrate = (action, path, initialState) =>
    _get(action, path, false) || initialState;
